<template>
  <div class="sala-atendimento">
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Sala de atendimento</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Atenção, no momento você está em atendimento
          </h5>
        </div>
      </v-container>
    </div>
    <div class="pa-3">
      <div class="whereby">
        <whereby-embed
          @participant_join="onParticipantJoin"
          v-if="roomUrl"
          class="whereby-embed"
          audio="on"
          video="on"
          :room="roomUrl"
        ></whereby-embed>
        <div v-else>
          <v-skeleton-loader class="mx-auto" type="image"></v-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import meetingService from '@/services/meeting'

export default {
  name: 'SalaAtendimentoHai',
  data() {
    return {
      idAsoMeetingRoom: null,
      idMeetingRoom: null,
      roomUrl: null,
      timer: null
    }
  },
  methods: {
    async enterOnMeetingRoom() {
      if (this.idAsoMeetingRoom && this.idMeetingRoom) {
        try {
          this.loading = true
          const { data } = await meetingService.enterOnRoom(this.idAsoMeetingRoom, this.idMeetingRoom)
          this.roomUrl = data.meetingRoomUrl
          this.timer = setInterval(this.roomStatus, 5000)
        } catch ({ response }) {
          this.$showErrorMessage(response.data.message)
          this.$router.push({ name: 'erro-atendimento-hai' })
        } finally {
          this.loading = false
        }
      }
    },
    async roomStatus() {
      const { data } = await meetingService.checkAppointmentStatus(this.idAsoMeetingRoom)
      if (data.status === 'finalizado') {
        this.$router.push({ name: 'sucesso-atendimento-hai' })
      } else if (data.status !== 'em_atendimento') {
        this.$showErrorMessage('Não foi possivel continuar o atendimento no momento')
      }
    },
    onParticipantJoin() {
      this.userHasJoined = true
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {
    this.enterOnMeetingRoom()
  },
  created() {
    this.idMeetingRoom = this.$route.query.room
    this.idAsoMeetingRoom = this.$route.query.id
  }
}
</script>
<style scoped>
.whereby {
  overflow-y: hidden;
}
.sala-atendimento >>> .v-skeleton-loader__image {
  height: 70vh !important;
}

.whereby-embed {
  height: 70vh !important;
  margin-top: -35px;
  /* border-radius: 10px; */
}
</style>
